// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__BsI1z","spin":"spinner_spin__Ek3GX"};